import { MissionData } from '../blocks/mission'
import template from './templates/RJS07.rbxl'
import thumbnail1 from './thumbnails/RJS07/SpawnLocation.png'
import thumbnail2 from './thumbnails/RJS07/Ball.png'
import thumbnail3 from './thumbnails/RJS07/Hashira.png'
const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①スタートちてん',
      thumbnail: thumbnail1,
      sound: true,
    },
    {
      name: '②ボール',
      thumbnail: thumbnail2,
    },
    {
      name: '③はしら',
      thumbnail: thumbnail3,
    },
  ],
}

export default mission
